<form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">Create Scheduled course</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>

      <div class="form-group col-sm-12">
        <div class="col-sm-3">
          <label for="first-name">{{lang?.courseCode}}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="sc_couse_code"
            [ngClass]="formErrorClass(createForm.controls.sc_couse_code, createFormSubmitted)">

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.sc_couse_code, value:createForm.controls.sc_couse_code, submitted:createFormSubmitted }">
          </ng-template>
        </div>

      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label for="first-name">{{lang?.catalogCode}}</label>
        </div>
        <div class="form-group col-sm-9">
          <select class="form-control" formControlName="sc_catalog_code" (change)="getCatloqCode($event.target.value)"
            [ngClass]="formErrorClass (createForm.controls.sc_catalog_code, createFormSubmitted)">
            <option value="">Select Code</option>
            <option *ngFor="let resp of data.get_catalog_data" [value]="resp.catalogId">{{resp?.catalogId}} - {{ resp?.cat_course_name }}</option>
          </select>

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.code, value:createForm.controls.code, submitted:createFormSubmitted }">
          </ng-template>
        </div>

      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label for="first-name">{{lang?.courseTitle}}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="sc_course_name" disabled
            [ngClass]="formErrorClass(createForm.controls.sc_course_name, createFormSubmitted)">

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.sc_course_name, value:createForm.controls.sc_course_name, submitted:createFormSubmitted }">
          </ng-template>
        </div>

      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label for="first-name">{{lang?.courseCategory}}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="sc_course_catgy" disabled
            [ngClass]="formErrorClass(createForm.controls.sc_course_catgy, createFormSubmitted)">

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.sc_course_catgy, value:createForm.controls.sc_course_catgy, submitted:createFormSubmitted }">
          </ng-template>
        </div>

      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label for="first-name">{{lang?.durationHours}}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="sc_duration" disabled
            [ngClass]="formErrorClass(createForm.controls.sc_duration, createFormSubmitted)">

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.sc_duration, value:createForm.controls.sc_duration, submitted:createFormSubmitted }">
          </ng-template>
        </div>

      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label for="first-name">{{lang?.place_of_performance}}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="place_perf"
            [ngClass]="formErrorClass(createForm.controls.place_perf, createFormSubmitted)">

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.place_perf, value:createForm.controls.place_perf, submitted:createFormSubmitted }">
          </ng-template>
        </div>

      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label for="first-name">{{lang?.actuator_body}}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="act_body"
            [ngClass]="formErrorClass(createForm.controls.act_body, createFormSubmitted)">

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.act_body, value:createForm.controls.act_body, submitted:createFormSubmitted }">
          </ng-template>
        </div>

      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label for="first-name">{{lang?.main_teacher}}</label>
        </div>
        <div class="form-group col-sm-9">
            <select class="form-control" formControlName="sc_teacher_name" 
            [ngClass]="formErrorClass(createForm.controls.sc_teacher_name, createFormSubmitted)" >
              <option *ngFor="let teacher of selectedTeachers;let selIndex = index" [selected]="selIndex == 0" [value]="teacher?.value"> {{ teacher?.name }} </option>
            </select>            

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.sc_teacher_name, value:createForm.controls.sc_teacher_name, submitted:createFormSubmitted }">
          </ng-template>
        </div>

      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label for="first-name">{{lang?.select_status}}</label>
        </div>
        <div class="form-group col-sm-9">
          <select class="form-control" formControlName="sched_staus" 
            [ngClass]="formErrorClass (createForm.controls.sched_staus, createFormSubmitted)">
            <option value="Programmed" selected>{{lang?.select_status}}</option>
            <option value="Active">{{lang?.active}}</option>
            <option value="Finished">{{lang?.finished}}</option>
            <option value="Suspended">{{lang?.suspended}}</option>
            <option value="UNDEFINITED">{{lang?.undefined}}</option>
          </select>

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.sched_staus, value:createForm.controls.sched_staus, submitted:createFormSubmitted }">
          </ng-template>
        </div>

      </div>      

      <div class="col-sm-12">
        <div class="panel panel-default">
          <div class="panel-heading"> 
           {{lang?.scheduled_courses}}
          </div>
          <div class="panel-body">
             <div class="table-responsive ">
            <table class="table table-striped scheduled-course">
              <thead>
                <th>{{lang?.module_number}} </th>
                <th>{{lang?.title}} </th>
                <th>{{ lang?.durationHours }} </th>
                <th>{{ lang?.teacher_title }} </th>
                <th>{{ lang?.startDate }} </th>
                <th>{{ lang?.endDate }} </th>
                <th>{{ lang?.execution_dates }} </th>
              </thead>
              <tbody id="add_rows">
                <tr *ngFor="let courseGroup of createForm.get('sc_courses')?.controls;let i = index" [formGroup]="courseGroup">
                <td><input type="text" class="form-control" formControlName="no_modle"  [ngClass]="formErrorClass(courseGroup.controls.no_modle, createFormSubmitted)" /></td>
                <td><input type="text" class="form-control" formControlName="mod_arg"   [ngClass]="formErrorClass(courseGroup.controls.mod_arg, createFormSubmitted)" /></td>
                <td><input type="text" class="form-control" formControlName="mod_durat" [ngClass]="formErrorClass(courseGroup.controls.mod_durat, createFormSubmitted)"  /></td>
                <td>
                  <!-- <input type="text" class="form-control" formControlName="teacher_name"  /> -->
                  <select class="form-control" formControlName="teacher_name" [ngClass]="formErrorClass(courseGroup.controls.teacher_name, createFormSubmitted)" >
                    <option *ngFor="let teacher of getTeachers(i);let selIndex = index" [selected]="selIndex == 0" [value]="teacher?.value"> {{ teacher?.name }} </option>
                  </select>
                </td>
                <td><input type="date" class="form-control" formControlName="start_date" [ngClass]="formErrorClass(courseGroup.controls.start_date, createFormSubmitted)"  /></td>
                <td><input type="date" class="form-control" formControlName="end_date" [ngClass]="formErrorClass(courseGroup.controls.end_date, createFormSubmitted)"   /></td>
                <td><input type="date" class="form-control" formControlName="exec_dates" [ngClass]="formErrorClass(courseGroup.controls.exec_dates, createFormSubmitted)"   /></td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>
        </div>        
      </div>


    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ lang?.save }}</button>
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ lang?.close }}</button>

  </div>


</form>
